(function () {
  if (window.__galleryReloadBound) return;
  window.__galleryReloadBound = true;

  function getContext(el) {
    const productInfo = el?.closest?.('product-info') || document.querySelector('product-info');
    if (!productInfo) return null;
    const sectionId  = productInfo.dataset.section;
    // Ensure absolute URL for fetch
    const productUrl = new URL(productInfo.dataset.url || location.href, location.origin);
    productUrl.search = ''; // start clean; we’ll set params explicitly
    return { productInfo, sectionId, productUrl };
  }

  async function reloadGalleryForVariant(variantId, sourceEl) {
    const ctx = getContext(sourceEl);
    if (!ctx) return;
    const { sectionId, productUrl } = ctx;

    // Keep location in sync (optional)
    try {
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set('variant', variantId);
      history.replaceState({}, '', newUrl);
    } catch (_) {}

    // Build section render URL
    const url = new URL(productUrl.href);
    url.searchParams.set('variant', variantId);
    url.searchParams.set('section_id', sectionId);

    let html;
    try {
      const res = await fetch(url.toString(), { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      html = await res.text();
    } catch (err) {
      console.error('[GalleryReload] fetch failed', err);
      return;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const sel = `#MediaGallery-${CSS.escape(sectionId)}`;
    const newGallery = doc.querySelector(sel);
    const oldGallery = document.querySelector(sel);
    if (!newGallery || !oldGallery) return;

    // Clean up old instances completely
     try {
	  // Force-close any open lightbox *before* destroying it
	  if (oldGallery.lightbox && typeof oldGallery.lightbox.close === 'function') {
	    oldGallery.lightbox.close();
	  }

	  // Destroy the JS instance
	  oldGallery.lightbox?.destroy?.();

	  // --- A_DD THIS LINE ---
	  // Manually remove any lingering PhotoSwipe DOM from the body
	  document.querySelectorAll('body > .pswp').forEach(el => el.remove());
	  // --- END ADDED LINE ---

	  // Destroy Swiper instances
	  oldGallery.sliderInstance?.slider?.destroy?.(true, true);
	  oldGallery.thumbsInstance?.slider?.destroy?.(true, true);
	} catch (e) {
	  // noop
	}

     oldGallery.replaceWith(newGallery);
    // Ensure the custom element is initialized
    try {
      await customElements.whenDefined('media-gallery');
      // Give layout a tick so Swiper can compute sizes
      requestAnimationFrame(() => {
        // If your theme exposes an init hook, call it:
        // window.FoxTheme?.utils?.initComponents?.(newGallery);
        // Otherwise, the element's connectedCallback should auto-init.
      });
    } catch (_) {}

    // Optional: nudge viewport to the gallery on desktop
    if (window.matchMedia('(min-width: 768px)').matches) {
      const wrap = newGallery.closest('.product__media-container');
      if (wrap) window.scrollTo({ top: wrap.offsetTop - 40, behavior: 'smooth' });
    }
  }

  // Prefer the theme’s pub/sub
  const bus = window.FoxTheme?.pubsub;
  const EVENTS = bus?.PUB_SUB_EVENTS;

  if (bus && EVENTS?.variantChange) {
    bus.subscribe(EVENTS.variantChange, ({ data, target }) => {
      const variantId = data?.variant?.id;
      if (variantId) reloadGalleryForVariant(variantId, target);
    });
  } else {
    // Fallback: detect option changes and resolve variant
    document.addEventListener('change', (ev) => {
      const info = ev.target?.closest?.('product-info');
      if (!info) return;
      const jsonEl = info.querySelector('[type="application/json"][data-product]');
      if (!jsonEl) return;
      let product;
      try { product = JSON.parse(jsonEl.textContent); } catch (_) { return; }

      const optionEls = [...info.querySelectorAll('[name^="options["]')];
      const selected = optionEls.map((el) =>
        el.type === 'radio'
          ? (info.querySelector(`input[name="${el.name}"]:checked`) || {}).value
          : el.value
      );

      const match = product.variants.find(v => v.options.every((opt, i) => opt === selected[i]));
      if (match) reloadGalleryForVariant(match.id, info);
    });
  }

  // Theme Editor: section reloads
  document.addEventListener('shopify:section:load', () => {
    // no-op: listener is global & idempotent
  });
})();
